/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VirtualServiceModalModule
 */

import {
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as l10n from './vs-attach-waf-in-eval-mode.l10n';
import './vs-attach-waf-in-eval-mode.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component to confirm attaching WAF in evaluation mode to virtual service.
 * @author Shanmukha Sarath Kondiparthi
 */
@Component({
    selector: 'vs-attach-waf-in-eval-mode',
    templateUrl: './vs-attach-waf-in-eval-mode.component.html',
})
export class VsAttachWafInEvalModeComponent {
    @Input()
    public wafPolicyName = '';

    @Input()
    public isWafPolicyPresent = true;

    @Output()
    public readonly onClose = new EventEmitter<void>();

    @Output()
    public readonly onConfirm = new EventEmitter<void>();

    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Handle user clicking -> Cancel.
     */
    public handleCancel(): void {
        this.onClose.emit();
    }

    /**
     * Handle user clicking -> Yes, Continue.
     */
    public handleContinue(): void {
        this.onConfirm.emit();
    }
}
